import React, { useState } from 'react'
import Logo from "../assets/logo.png"
import { FaBars } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";

const Header = () => {
   let [show,setshow]  = useState(false)
   let handelshow = () =>{
      setshow(!show)
   }

  return (
  <section id='Navber' className=' bg-fixed'>
     <div className='max-w-container mx-auto h-[90px] w-full flex pt-[10px] bg-[#ffffffd7]'>

     <div className=' lg:w-[30%] h-full w-[50%]'>
        <img src={Logo} alt="Logo" />
     </div>
     <div className='w-[70%] h-full'>
        <div className=' items-center justify-center pt-[23px]'>
        <ul className={`lg:flex  lg: justify-around lg: items-center font-rem  lg: gap-x-6 absolute left-0 top-0 lg:static ${show ? " top-[50px] left-0 w-full bg-[#292929bf] transition duration-300 ease-in-out" : " top-[-300px] left-0 w-full transition duration-300 ease-in-out"}`}>
            <li className='py-[10px] text-center'><a href="#" className='text-[20px] font-semibold font-rem lg:text-[#0B0B0B] text-white hover:text-[#EA580C]'>Home</a></li>
            <li className='py-[10px] text-center'><a href="#" className='text-[20px] font-semibold  font-rem lg:text-[#0B0B0B] text-white hover:text-[#EA580C]'>About</a></li>
            <li className='py-[10px] text-center'><a href="#" className='text-[20px] font-semibold  font-rem lg:text-[#0B0B0B] text-white hover:text-[#EA580C]'>Service</a></li>
            <li className='py-[10px] text-center'><a href="#" className='text-[20px] font-semibold  font-rem lg:text-[#0B0B0B] text-white hover:text-[#EA580C]'>Contact</a></li>

            <button className='lg:h-[56px] lg:w-[243px] h-[40px] w-[143px] lg:ml-0 ml-[110px] bg-[#EA580C] border-solid border-[2px] rounded-[20px] border-[#EA580C]  hover:bg-[#fb8e4f98] text-orange-500 sm:text-center  lg:mb-[0] mb-[20px]'>
      <div className='flex text-center font-rem lg:pl-[45px]'>

      <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
<g clip-path="url(#clip0_7_6)">
<path d="M5.98012 15.4896C5.81219 15.9045 5.71383 16.3598 5.70494 16.8363C5.6663 18.9062 7.31435 20.6169 9.3843 20.6556C10.1537 20.6699 10.8767 20.449 11.4778 20.0617C12.5246 21.9566 14.5203 23.2519 16.8363 23.2951C20.2889 23.3596 23.1374 20.6154 23.2019 17.1629C23.2039 17.0574 23.2019 16.9519 23.2 16.8464C25.4015 16.1178 27.0104 14.0615 27.0562 11.6088C27.1142 8.50389 24.6421 5.93778 21.5372 5.87982L7.16468 5.61154C4.40344 5.56 2.12377 7.75612 2.07223 10.5174C2.02711 12.9349 3.70787 14.9862 5.98012 15.4896ZM11.6567 13.1967L14.211 13.2444L14.2926 8.87014C14.299 8.52644 14.5855 8.25049 14.9292 8.25691L16.8038 8.2919C17.1475 8.29832 17.4235 8.58477 17.4171 8.92846L17.3354 13.3027L19.8897 13.3504C20.4481 13.3608 20.7129 14.0377 20.3111 14.4248L16.1178 18.4645C15.8711 18.7021 15.4727 18.6947 15.2351 18.448L11.1955 14.2547C10.8084 13.8529 11.1021 13.1863 11.6567 13.1967Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_7_6">
<rect width="25" height="25" fill="white" transform="translate(28.0579 25.844) rotate(174.92)"/>
</clipPath>
</defs>
</svg>
<h5 className='lg:pl-[20px] pl-[10px] lg:mt-0 mt-[-2px] text-[#fff] text-[20px] font-medium'>Download</h5>
      </div>
        </button>
        </ul>
        <div className=' lg:hidden ml-[180px] mt-[-10px] text-end justify-end items-end'onClick={handelshow}>
         {show == true ? <RxCross2/> : <FaBars/>}
        </div>
        </div>
     </div>



     </div>

  </section>
  )
}

export default Header